module.exports = __webpack_public_path__ + "img/facilita-marketplace-icon-escuro.60155b03.svg";